import { FlexBox, Icon } from '@fable/components'
import { css } from '@fable/theme'
import { useStatsModal } from './lib/ctx/stats_modal'
import { useRef } from 'react'
import { useClickOutside } from '@fable/hooks'
import { useStatsTheme } from './theme/ctx'

export const StatsModal = () => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOpen, content, close] = useStatsModal((s) => [
    s.isOpen,
    s.content,
    s.close,
  ])
  const theme = useStatsTheme((s) => s.theme)

  useClickOutside(ref, () => isOpen && close())

  return (
    <FlexBox
      className={css`
        width: 100%;
        height: 100dvh;
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        transition: opacity ease 0.2s;
        opacity: ${isOpen ? 1 : 0};
        pointer-events: ${isOpen ? 'auto' : 'none'};
        z-index: 1000;
      `}
      centerAll
    >
      <FlexBox
        ref={ref}
        className={css`
          padding: 20px;
          width: 100%;
          max-width: 390px;
          background-color: ${theme.colors.section.bgSecondary};
          min-height: 200px;
          border-radius: 12px;
          position: relative;
          gap: 12px;
          max-height: 80%;
          overflow-y: auto;
          box-shadow: 0px 8px 36px 0px rgba(0, 0, 0, 0.17);
        `}
      >
        <FlexBox
          role="button"
          aria-label="close share modal"
          className={css`
            width: 24px;
            height: 24px;
            background-color: ${theme.colors.section.textSecondary};
            border-radius: 50%;
            position: absolute;
            top: 20px;
            right: 20px;
            opacity: ${theme.id.includes('dark') ? 0.8 : 0.5};
          `}
          onClick={close}
          centerAll
        >
          <Icon
            className={css`
              width: 16px;
            `}
            type="close"
            fill={theme.colors.section.bg}
          />
        </FlexBox>
        <div
          className={css`
            padding-top: 36px;
          `}
        >
          {content}
        </div>
      </FlexBox>
    </FlexBox>
  )
}
